import React, { useRef } from 'react';
import { Center, Text3D } from "@react-three/drei";
import { useFrame } from "@react-three/fiber";
import { animated, useSpring } from "@react-spring/three";
import { useAtom } from 'jotai';
import { alertsAtom, languageAtom } from '../GlobalState';
import Star from '../meshes/Stars/Star';
import translations from '../dictionaries/translations';

export default function JoinAlert({ scale, rotation=[0,0,0] }) {      
  const [alerts] = useAtom(alertsAtom);
  const alertString = alerts[0]

  const [language] = useAtom(languageAtom);
  const fontUrl = language === 'korean' ? "/fonts/Maplestory_Bold.json" : language === 'chinese' ? "/fonts/Xiao Xiangjiao font_Regular.json" : "/fonts/Luckiest Guy_Regular.json";
  

  // alertString[4] is the team index
  let team = alertString && parseInt(alertString[4]);
  let tile = alertString && parseInt(alertString.substring(5, alertString.length));

  // Specific location for each tile
  let position;
  // Fourth quadrant
  if (tile === 1 || tile === 2 || tile === 3 || tile === 4 || tile === 22 || tile === 27 || tile == 28 || tile === 0) {
    position = [
      2.3, 0, 1.5
    ]
  // First quadrant
  } else if (tile === 5 || tile === 6 || tile === 7 || tile === 8 || tile === 9 || tile === 25 || tile === 26 || tile === 20 || tile === 21) {
    position = [
      2.3, 0, -2.5
    ]
  // Second quadrant
  } else if (tile === 10 || tile === 11 || tile === 12 || tile === 13 || tile === 14 || tile === 23 || tile === 24) {
    position = [
      -2.3, 0, -2.5
    ]
  // Third quadrant
  } else {
    position = [
      -2.3, 0, 1.5
    ]
  }

  const borderMesh0Ref = useRef();
  const borderMesh1Ref = useRef();
  const borderMesh2Ref = useRef();
  const borderMesh3Ref = useRef();
  const borderMesh4Ref = useRef();
  const borderMesh5Ref = useRef();
  const borderMesh6Ref = useRef();
  const borderMeshRefs = [
    borderMesh0Ref,
    borderMesh1Ref,
    borderMesh2Ref,
    borderMesh3Ref,
    borderMesh4Ref,
    borderMesh5Ref,
    borderMesh6Ref
  ]

  const height = 0.7
  const width = 1.8
  const starScale = 0.08
  useFrame((state, delta) => {
    for (let i = 0; i < borderMeshRefs.length; i++) {      
      borderMeshRefs[i].current.position.x = Math.cos(state.clock.elapsedTime / 2 + 2 * Math.PI/borderMeshRefs.length * i) * width
      borderMeshRefs[i].current.position.y = 0.05
      borderMeshRefs[i].current.position.z = Math.sin(state.clock.elapsedTime / 2 + 2 * Math.PI/borderMeshRefs.length * i) * height
    }
  })

  return <animated.group position={position} scale={scale}>
      <mesh scale={[width, 1,height]}>
        <cylinderGeometry args={[1, 1, 0.01, 32]}/>
        <meshStandardMaterial color='black' transparent opacity={0.9}/>
      </mesh>
      <Center position={[0, 0.1, 0]} key={Math.random()}>
        <Text3D
          font={fontUrl}
          position={[-1.27, 0.1, 0.2]}
          rotation={[-Math.PI/2, 0, 0]}
          height={0.01}
          lineHeight={0.9} 
          size={0.35}
        >
          {translations.alerts.piggyback[language]}  
          <meshStandardMaterial color={team === 0 ? 'red': 'turquoise'}/>
        </Text3D>
      </Center>
      <group ref={borderMesh0Ref}>
        <Star scale={starScale} color={team === 0 ? 'red': 'turquoise'} />
      </group>
      <group ref={borderMesh1Ref}>
        <Star scale={starScale} color={team === 0 ? 'red': 'turquoise'} />
      </group>
      <group ref={borderMesh2Ref}>
        <Star scale={starScale} color={team === 0 ? 'red': 'turquoise'}/>
      </group>
      <group ref={borderMesh3Ref}>
        <Star scale={starScale} color={team === 0 ? 'red': 'turquoise'} />
      </group>
      <group ref={borderMesh4Ref}>
        <Star scale={starScale} color={team === 0 ? 'red': 'turquoise'} />
      </group>
      <group ref={borderMesh5Ref}>
        <Star scale={starScale} color={team === 0 ? 'red': 'turquoise'} />
      </group>
      <group ref={borderMesh6Ref}>
        <Star scale={starScale} color={team === 0 ? 'red': 'turquoise'} />
      </group>
  </animated.group>
}